// extracted by css-extract-rspack-plugin
export default {"labelDotsContainer":"LabelDots-module__labelDotsContainer__AyY75aJ","labelDot":"LabelDots-module__labelDot__L1LDXw7"};